// extracted by mini-css-extract-plugin
export var actionButton = "_7j-0";
export var attachmentLine = "_7j-1";
export var fileInput = "_7j-2";
export var fileUploadWrapper = "_7j-4";
export var footer = "_7j-3";
export var modalContent = "_7j-5";
export var paperclip = "_7j-6";
export var quillEditor = "_7j-7";